import React, { Fragment } from 'react';

import { formatFigure, formatMoneyWithLocale } from 'Helpers/formatService';

const figure = (value) => formatFigure(value, formatMoneyWithLocale, { precision: 3 });

export default function ProcurementRevenuesTable({ treeIndex, data = [], total }) {
    if (!data.length) {
        return null;
    }

    return (
        <div>
            <h4 className="table__header tw-mb-6">{treeIndex >= 1 ? $t('Contract Variation') + ' ' + treeIndex : $t('Revenues')}</h4>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th>{$t('Name')}</th>
                            <th>{$t('Department / Cost Centre')}</th>
                            <th>{$t('Cash')}</th>
                            <th>{$t('VIK')}</th>
                            <th>{$t('Total')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* Keyed by position: the value DTO behind these rows carries no identifier. */}
                        {data.map((revenue, index) => (
                            <Fragment key={index}>
                                <tr>
                                    <td>{revenue.name}</td>
                                    <td>
                                        {revenue.department}
                                        {revenue.costcenter ? ` / ${revenue.costcenter}` : ''}
                                    </td>
                                    <td className="inbud-numeric-cell">{figure(revenue.cash)}</td>
                                    <td className="inbud-numeric-cell">{figure(revenue.vik)}</td>
                                    <td className="inbud-numeric-cell">{figure(revenue.total)}</td>
                                </tr>
                            </Fragment>
                        ))}
                        <tr>
                            <td colSpan="4"></td>
                            <td className="tw-font-semibold inbud-numeric-cell">{figure(total)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}
